import * as ko from "knockout";
import { Api } from "../app-api";
import { App } from "../app";

const divRoot: HTMLDivElement = document.querySelector("#ko-jointheteam");
const divModel: HTMLDivElement = document.querySelector("#divJoinTheTeamModel");

export class ViewModel {
    showVolunteerLinks: () => void;

    constructor() {
        let self = this;

        self.showVolunteerLinks = () => {
            Api.GetVolunteerLinksInfo()
                .done(results => {
                    App.showInfo(results, "Apply for Youth Volunteer Opportunities");
                });
        }
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(), divRoot);
    }
}

$(document).ready(() => init());